export { default as translations } from './translations.json';

/**
 * Get auto-response config from user.
 * @param {Object|null} user
 * @returns {Object|null}
 */
export const getAutoResponseConfig = (user) =>
  user?.attributes?.profile?.publicData?.autoResponse || null;

export const isAutoResponseEnabled = (user) =>
  getAutoResponseConfig(user)?.enabled === true;

/**
 * Fill auto-response template variables.
 * @param {string} template
 * @param {Object} vars — { customerName, listingTitle }
 * @returns {string}
 */
export const fillTemplate = (template, vars = {}) => {
  if (!template) return '';
  return template
    .replace('{customerName}', vars.customerName || 'there')
    .replace('{listingTitle}', vars.listingTitle || 'this listing');
};
